export const PLAY_VIDEO = 'PLAY_VIDEO';
export const SHARE_SPY_ROLE = 'SHARE_SPY_ROLE';

/* Comparison Pages - Invite Friends */
export const CLICK_COMPARISON_INVITE_BUTTON = 'CLICK_COMPARISON_INVITE_BUTTON';
export const COPY_COMPARISON_INVITE_URL = 'COPY_COMPARISON_INVITE_URL';
export const SHARE_COMPARISON_INVITE_URL = 'SHARE_COMPARISON_INVITE_URL';

/* Dashboard Page */
export const SHOW_DOSSIER_PURCHASE_MODAL = 'SHOW_DOSSIER_PURCHASE_MODAL';
export const BEGIN_DOSSIER_PURCHASE = 'BEGIN_DOSSIER_PURCHASE';

// (missing eslint-config-prettier, but adding it would mean reformatting a whole bunch of files)
// eslint-disable-next-line operator-linebreak
export const SHOW_DOSSIER_PURCHASE_SUCCESS_MODAL =
  'SHOW_DOSSIER_PURCHASE_SUCCESS_MODAL';
